module.exports = __webpack_public_path__ + "static/media/matnrrd_3-436w.75bd385c.png";